<script setup lang="ts">
import type { Component, DefineComponent } from 'vue';
import { ref, markRaw } from 'vue';
import {
  Beverage,
  BxsDish,
  CakeOutlinedIcon,
  DrinkIcon,
  Hotpot,
  Noodle,
  Pizza,
  Rice,
  Shrimp,
  ChevronDown,
} from '@xpos/icons-svg';

const $props = defineProps<{
  modelValue?: string;
}>();
const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);

const icons: { [key: string]: Component } = {
  '1': markRaw(Shrimp),
  '2': markRaw(Pizza),
  '3': markRaw(Beverage),
  '4': markRaw(Hotpot),
  '5': markRaw(Rice),
  '6': markRaw(Noodle),
  '7': markRaw(DrinkIcon),
  '8': markRaw(CakeOutlinedIcon),
  '9': markRaw(BxsDish),
};

// @ts-ignore
const icon = ref<Component>($props.modelValue ? icons[$props.modelValue] : undefined);

const handleCommand = (key: string) => {
  if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
  icon.value = icons[key];
  $emit('change', key);
  $emit('update:value', key);
  $emit('update:modelValue', key);
};
</script>

<template>
  <el-dropdown :teleported="true" @command="handleCommand" trigger="click" class="w-full">
    <!-- <el-space>
      <el-icon size="20"><component :is="icon" /></el-icon>
      <el-icon size="20"><ChevronDown /></el-icon
    ></el-space> -->
    <div
      class="flex justify-between items-center bg-white h-[48px] border border-[#a8a8a8] w-full p-[10px] rounded-[10px]"
    >
      <el-icon size="30" color="#3A3A3A"><component :is="icon" /></el-icon>
      <el-icon size="20"><ChevronDown /></el-icon>
    </div>
    <template #dropdown>
      <el-dropdown-menu style="width: 420px">
        <el-dropdown-item command="1">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <Shrimp />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="2">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <Pizza />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="3">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <Beverage />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="4">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <Hotpot />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="5">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <Rice />
            </el-icon>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="6">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <Noodle />
            </el-icon>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
      <el-dropdown-menu>
        <el-dropdown-item command="7">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <DrinkIcon />
            </el-icon>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
      <el-dropdown-menu>
        <el-dropdown-item command="8">
          <div class="w-[100px] pl-[20px] text-left">
            <el-icon size="20">
              <CakeOutlinedIcon />
            </el-icon>
          </div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>
